// extracted by mini-css-extract-plugin
export var actionPlaceholder = "_8t-3";
export var contentContainer = "_8t-0";
export var editorContainer = "_8t-1";
export var quillInputForm = "_8t-2";
export var zoneDivider = "_8t-4";